// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as PaymentType$OrcaPaymentPage from "../Types/PaymentType.bs.js";
import * as PaymentField$OrcaPaymentPage from "./PaymentField.bs.js";
import * as DropdownField$OrcaPaymentPage from "./DropdownField.bs.js";

function PhoneNumberPaymentInput(props) {
  let phoneRef = React.useRef(null);
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.optionAtom);
  let showDetails = PaymentType$OrcaPaymentPage.getShowDetails(match.fields.billingDetails);
  let match$1 = Jotai.useAtom(JotaiAtoms$OrcaPaymentPage.userPhoneNumber);
  let setPhone = match$1[1];
  let clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  let clientCountry = Utils$OrcaPaymentPage.getClientCountry(clientTimeZone);
  let currentCountryCode = Utils$OrcaPaymentPage.getCountryCode(clientCountry.countryName);
  let match$2 = React.useState(() => "");
  let setDisplayValue = match$2[1];
  let countryAndCodeCodeList = Utils$OrcaPaymentPage.getArray(Core__Option.getOr(Core__JSON.Decode.object(Utils$OrcaPaymentPage.phoneNumberJson), {}), "countries");
  let phoneNumberCodeOptions = Core__Array.reduce(countryAndCodeCodeList, [], (acc, countryObj) => {
    let countryObjDict = Utils$OrcaPaymentPage.getDictFromJson(countryObj);
    let countryFlag = Utils$OrcaPaymentPage.getString(countryObjDict, "country_flag", "");
    let phoneNumberCode = Utils$OrcaPaymentPage.getString(countryObjDict, "phone_number_code", "");
    let countryName = Utils$OrcaPaymentPage.getString(countryObjDict, "country_name", "");
    let phoneNumberOptionsValue_value = countryFlag + `#` + phoneNumberCode;
    let phoneNumberOptionsValue_label = countryFlag + ` ` + countryName + ` ` + phoneNumberCode;
    let phoneNumberOptionsValue_displayValue = countryFlag + ` ` + phoneNumberCode;
    let phoneNumberOptionsValue = {
      value: phoneNumberOptionsValue_value,
      label: phoneNumberOptionsValue_label,
      displayValue: phoneNumberOptionsValue_displayValue
    };
    acc.push(phoneNumberOptionsValue);
    return acc;
  });
  let defaultCountryCodeFilteredValue = Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(Core__Option.getOr(countryAndCodeCodeList.filter(countryObj => Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(countryObj), "country_code", "") === currentCountryCode.isoAlpha2)[0], {
    phone_number_code: ""
  })), "phone_number_code", "");
  let match$3 = React.useState(() => defaultCountryCodeFilteredValue);
  let valueDropDown = match$3[0];
  let getCountryCodeSplitValue = val => Core__Option.getOr(val.split("#")[1], "");
  let changePhone = ev => {
    let val = ev.target.value.replace(/\D|\s/g, "");
    setPhone(prev => {
      let newrecord = {...prev};
      newrecord.countryCode = getCountryCodeSplitValue(valueDropDown);
      newrecord.value = val;
      return newrecord;
    });
  };
  React.useEffect(() => {
    setPhone(prev => {
      let newrecord = {...prev};
      newrecord.countryCode = getCountryCodeSplitValue(valueDropDown);
      return newrecord;
    });
  }, [valueDropDown]);
  React.useEffect(() => {
    let findDisplayValue = Core__Option.getOr(phoneNumberCodeOptions.find(ele => ele.value === valueDropDown), DropdownField$OrcaPaymentPage.defaultValue);
    setDisplayValue(param => Core__Option.getOr(findDisplayValue.displayValue, Core__Option.getOr(findDisplayValue.label, findDisplayValue.value)));
  }, [phoneNumberCodeOptions]);
  return JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
    condition: showDetails.phone === "Auto",
    children: JsxRuntime.jsx(PaymentField$OrcaPaymentPage.make, {
      value: match$1[0],
      valueDropDown: valueDropDown,
      setValueDropDown: match$3[1],
      dropDownOptions: phoneNumberCodeOptions,
      onChange: changePhone,
      fieldName: "Phone Number",
      name: "phone",
      type_: "tel",
      paymentType: "Payment",
      maxLength: 14,
      placeholder: "000 000 000",
      inputRef: phoneRef,
      displayValue: match$2[0],
      setDisplayValue: setDisplayValue
    })
  });
}

let make = PhoneNumberPaymentInput;

export {
  make,
}
/* jotai Not a pure module */
